import Vue from 'vue'
import Router from 'vue-router'
import Home from 'views/Home'
import MonthlyAnalytics from 'views/MonthlyAnalytics'
import Seo from 'views/Seo'
import Support from 'views/Support'
import AccountSetting from 'views/AccountSetting'
import BusinessPromoter from 'views/BusinessPromoter'
import ReputationReport from 'views/ReputationReport'
import ReviewManagement from 'views/ReviewManagement'
import SocialMedia from 'views/SocialMedia'
import Login from 'views/Login'
import FindId from 'views/FindId'
import PasswordReset from 'views/Password-reset'
import FacebookLogin from 'views/FacebookLogin'
import CallInquiries from 'views/CallInquiries'
import CallInquiriesDashboard from 'views/CallInquiriesDashboard'
import ActionItemList from 'views/ActionItemList'
import WebInquiries from 'views/WebInquiries'
import ResetPassword from 'views/ResetPassword'
import BusinessPromoterDetail from 'views/BusinessPromoterDetail'
import Bills from 'views/Bills'
import BillsDetail from 'views/BillsDetail'
import PaymentHistory from 'views/PaymentHistory'
import MapScanGoogle from 'views/MapScanGoogle'
import MapScanYelp from 'views/MapScanYelp'
import MapScanList from 'views/MapScanList'
import Err404 from 'views/exception/Error404'
import UnLoginBills from 'views/UnLoginBills'
import GoogleAuthorize from 'views/GoogleAuthorize'
import GoogleLogin from 'views/GoogleLogin'
import AccountList from 'views/AccountList'
import AiBusinessPromoter from 'views/AiBusinessPromoter'
import StaffsList from 'views/StaffsList'
import CreateAiBusinessPromoter from 'views/CreateAiBusinessPromoter'
import ViewAiBusinessPromoter from 'views/ViewAiBusinessPromoter'
import EditAiBusinessPromoter from 'views/EditAiBusinessPromoter'
import SetAiBusinessPromoterInfo from 'views/SetAiBusinessPromoterInfo'
import AIBusinessPromoterDetail from 'views/AIBusinessPromoterDetail'

Vue.use(Router)

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    component: Home,
    meta: { title: 'Dashboard' },
  },
  {
    path: '/monthlyAnalytics',
    component: MonthlyAnalytics,
    meta: { title: 'Reporting', childTitle: 'Monthly Analytics' },
  },
  {
    path: '/seo',
    component: Seo,
    meta: { title: 'Reporting', childTitle: 'SEO Report' },
  },
  {
    path: '/support',
    component: Support,
    meta: { title: 'Support' },
  },
  {
    path: '/accountSetting',
    component: AccountSetting,
    meta: { title: 'Settings', childTitle: 'Account Setting' },
  },
  {
    path: '/accountList',
    component: AccountList,
    meta: { title: 'Settings', childTitle: 'Account' },
  },
  {
    path: '/resetPassword',
    component: ResetPassword,
    meta: { title: 'Settings', childTitle: 'Reset Password' },
  },
  {
    path: '/businessPromoter',
    component: BusinessPromoter,
    meta: { title: 'Review', childTitle: 'Business Promoter' },
  },
  {
    path: '/aiBusinessPromoter',
    component: AiBusinessPromoter,
    meta: { title: 'Review', childTitle: 'AI Business Promoter' },
  },
  {
    path: '/aiBusinessPromoter/create',
    component: CreateAiBusinessPromoter,
    meta: { title: 'Review', childTitle: 'AI Business Promoter' },
  },
  {
    path: '/staffsList',
    component: StaffsList,
    meta: { title: 'Review', childTitle: 'AI Business Promoter' },
  },
  {
    path: '/reputationReport',
    component: ReputationReport,
    meta: { title: 'Reporting', childTitle: 'Reputation Report' },
  },
  {
    path: '/reviewManagement',
    component: ReviewManagement,
    meta: { title: 'Review', childTitle: 'Review Management' },
  },
  {
    path: '/callInquiries',
    component: CallInquiries,
    meta: { title: 'Inquiries', childTitle: 'Call Inquiries'},
  },
  {
    path: '/actionItemList',
    component: ActionItemList,
    meta: { title: 'Inquiries', childTitle: 'Call Inquiries'},
  },
  {
    path: '/callInquiriesDashboard',
    component: CallInquiriesDashboard,
    meta: { title: 'Inquiries', childTitle: 'Call Inquiries'},
  },
  {
    path: '/webInquiries',
    component: WebInquiries,
    meta: { title: 'Inquiries', childTitle: 'Web Inquiries'},
  },
  {
    path: '/socialMedia',
    component: SocialMedia,
    meta: { title: 'Reporting', childTitle: 'Social Media' },
  },
  {
    path: '/bills-pay',
    component: Bills,
    meta: { title: 'Payments', childTitle: 'Bills' },
  },
  {
    path: '/bills/:uuid',
    component: UnLoginBills,
  },
  {
    path: '/billsDetail',
    component: BillsDetail,
    meta: { title: 'Payments', childTitle: 'Payment History Detail' },
  },
  {
    path: '/paymentHistory',
    component: PaymentHistory,
    meta: { title: 'Payments', childTitle: 'Payment History' },
  },
  {
    path: '/mapScanGoogle',
    component: MapScanGoogle,
    meta: { title: 'Map Scan', childTitle: 'Map Scan Google' },
  },
  {
    path: '/mapScanYelp',
    component: MapScanYelp,
    meta: { title: 'Map Scan', childTitle: 'Map Scan Yelp' },
  },
  {
    path: '/mapScanList',
    component: MapScanList,
    meta: { title: 'Map Scan', childTitle: 'Map Scan List' },
  },
  {
    path: '/login',
    component: Login
  },
  {
    path: '/findId',
    component: FindId
  },
  {
    path: '/password-reset/:code',
    component: PasswordReset
  },
  {
    path: '/review/business-promoter/:key',
    component: BusinessPromoterDetail
  },
  {
    path: '/review/business-promoter-ai/:key',
    component: AIBusinessPromoterDetail
  },
  {
    path: '/facebookLogin',
    component: FacebookLogin
  },
  {
    path: '/404',
    component: Err404
  },
  {
    path: '*',
    redirect: '/404',
  },
  {
    path: '/googleAuthorize',
    component: GoogleAuthorize
  },
  {
    path: '/googleLogin',
    component: GoogleLogin
  },
  {
    path: '/aiBusinessPromoter/detail/:uuid',
    component: ViewAiBusinessPromoter,
    meta: { title: 'Review', childTitle: 'AI Business Promoter' },
  },
  {
    path: '/aiBusinessPromoter/edit/:uuid',
    component: EditAiBusinessPromoter,
    meta: { title: 'Review', childTitle: 'AI Business Promoter' },
  },
  {
    path: '/aiBusinessPromoter/promptConfiguration',
    component: SetAiBusinessPromoterInfo,
    meta: { title: 'Review', childTitle: 'AI Business Promoter' },
  }
]
const router = new Router({
  routes,
  mode: 'history',
  scrollBehavior(to,from,savePosition){
    if(savePosition){
      return savePosition
    } else {
      return {x:0,y:0}
    }
  }
})
export default router
